/**
 * One CSV cell for the app's exports. Pure, no imports: the browser uses it
 * through src/lib/csv/csvCell.ts, and accountant-bundle writes its statement
 * CSV with it.
 *
 * Every cell is quoted with inner quotes doubled, and line breaks become
 * spaces (the Fio importer, src/lib/csv/fioCsvParser.ts, splits rows on "\n"
 * before it reads quotes). Text cells that a spreadsheet would read as a
 * formula (= + - @, tab or CR first) get a leading apostrophe: bank messages
 * and receipt vendors come from outside the company (payers, e-mailed
 * documents, AI extraction) and must not run when the file is opened.
 *
 * Numbers are exported with `{ text: false }` so a negative amount keeps its
 * minus sign.
 */
export function csvCell(value: unknown, options: { text?: boolean } = {}): string {
  const text = options.text ?? true;
  let s = value === null || value === undefined ? "" : String(value);
  s = s.replace(/\r\n|\r|\n/g, " ");
  if (text) s = neutralizeFormula(s);
  return `"${s.replace(/"/g, '""')}"`;
}

/**
 * A text cell a spreadsheet would read as a formula (= + - @, tab or CR
 * first) gets a leading apostrophe. Shared by the CSV and XLSX outputs, so a
 * sheet that is later saved as CSV stays safe too.
 */
export function neutralizeFormula(text: string): string {
  return /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
}

/** A CSV row from cells already encoded with csvCell. */
export const csvRow = (cells: string[]): string => cells.join(",");
